import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { combineLatest, Subject, Subscription } from 'rxjs';
import { filter, map, takeUntil, tap } from 'rxjs/operators';
import { Provenienza } from 'src/app/common/models/tipologiche/provenienza';
import { TipoDocumento } from 'src/app/common/models/tipologiche/tipo-documento';
import {
  FileFolders,
  TreeModel
} from '../../../../../common/components/fascicolo/documentazione-allegata-view/documentazione-allegata.component';
import { IdDescrittoriDiSezione, NomiDescrittoriSezione } from '../../../../../common/configuration/nomi-descrittori-sezione';
import { DescrittoreSezione } from '../../../../../common/models/descrittore-sezione';
import { DocumentoAllegato } from '../../../../../common/models/documento-allegato';
import { Fascicolo } from '../../../../../common/models/fascicolo/fascicolo';
import { Pratica } from '../../../../../common/models/pratica/pratica';
import { Sezione } from '../../../../../common/models/sezioni/sezione';
import { TipoSezione } from '../../../../../common/models/tipologiche/tipo-sezione';
import { ServicePathsSettings } from '../../../../../core/configuration/service-paths-settings';
import { HelpersService } from '../../../../../core/services/helpers.service';
import { OperationsService } from '../../../../../core/services/operations.service';
import { ViewManagerService } from '../../../../../core/services/view-manager-service';
import { CreazionePraticaStoreService } from '../../services/creazione-pratica-store.service';
import { CreazionePraticaTipologicheService } from '../../services/creazione-pratica-tipologiche.service';
import { CreazionePraticaService } from '../../services/creazione-pratica.service';
import { stepMap } from '../creazione-pratica-stepper/config/step';
import { TipoTipologica } from 'src/app/common/models/tipologiche/tipo-tipologica';
import { FileData } from 'src/app/common/models/file-data';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { FileUploadResponse } from 'src/app/common/models/dto/file-upload-response';
import { ResponseDocumentProtocol } from 'src/app/common/protocol/models/dto/response-document-protocol';
import { UpdateMetadatiDocumentoRequest } from 'src/app/common/models/dto/update-metadati-documento-request';
import { DataInput } from 'src/app/common/models/dto/data-input';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { CtxBodyAbstract } from 'src/app/common/models/ctx-body-abstract';
import { CtxBodyFascicolo } from 'src/app/common/models/ctx-body-fascicolo';
import { CtxMessage } from 'src/app/common/models/ctx-message';
import { MenuActions } from 'src/app/common/configuration/menu-actions';
import { IdCampiCtxMenu } from 'src/app/common/configuration/id-campi-ctx-menu';
import { ActivatedRoute, Params } from '@angular/router';
import { CtxBodyFascicoloIns } from 'src/app/common/models/ctx-body-fascicolo-ins';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { RoutingConfigurationUtilService } from 'src/app/core/services/routing-configuration-util.service';
import { IntestazioneFascicoloService } from 'src/app/common/services/intestazione-fascicolo-service';
import { FascicoliMappingService } from 'src/app/core/services/fascicoli-mapping.service';
import { FrontEndMapping } from 'src/app/core/configuration/front-end-mapping';
import { DocumentVersionUpdateModal } from 'src/app/common/components/documenti/documento-version-update/document-version-update-modal.component';
import { DocumentVersionHistoryModal } from 'src/app/common/components/documenti/documento-history-version/document-version-history-modal.component';
import { DocumentoAddModal } from 'src/app/common/components/documenti/documento-add/documento-add-modal.component';
import { DocumentoSpostaCategoriaModal } from 'src/app/common/components/documenti/documento-sposta/documento-sposta-modal.component';
import { DocumentUpdateMetadatiModal } from 'src/app/common/components/documenti/documento-update-metadati/document-update-metadati-modal.component';
import { ProtocollaDocumentoModalComponent } from 'src/app/common/components/documenti/protocolla-documento/protocolla-documento-modal.component';
import { DetailFolderFileComponent } from 'src/app/common/components/treeview-component/detail-folder-file/detail-folder-file.component';
import { ProtocolDocumentSelectionComponent } from 'src/app/common/protocol/components/protocol-document-selection/protocol-document-selection.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { UpdateMetadatiComponent } from 'src/app/common/components/fascicolo/documentazione-allegata-view/metadati/update-metadati/update-metadati.component';

@Component({
  selector: 'step-documentazione-allegata',
  templateUrl: './step-documentazione-allegata.component.html',
  styleUrls: ['./step-documentazione-allegata.component.css']
})
export class StepDocumentazioneAllegataComponent implements OnInit, OnDestroy {
  @ViewChild("docVersionUpdateModal")
  docVersionUpdateModal: DocumentVersionUpdateModal;
  @ViewChild("docVersionHistory")
  docVersionHistoryModal: DocumentVersionHistoryModal;
  @ViewChild("docAddModal") docAddModal: DocumentoAddModal;
  @ViewChild("docSpostaModal") docSpostaModal: DocumentoSpostaCategoriaModal;
  @ViewChild("docProtocolModal")
  docProtocolModal: ProtocollaDocumentoModalComponent;
  @ViewChild('detailFolder') detailDocument: DetailFolderFileComponent;
  @Input() fascicolo: any;
  addDocFormTitles: Array<string> = [];
  subscriptionFascicolo: Subscription;
  subscriptionIntestazioneFascicolo: Subscription;
  subscriptionListDocumentazione: Subscription;
  ctxBodyFascicolo: CtxBodyFascicolo;
  descrittoriSezione: DescrittoreSezione[];
  sezioni: Array<any> = new Array();
  readUrlArray: Array<string>;
  insertUrlArray: Array<string>;
  deleteUrlArray: Array<string>;
  addDocToEntity: boolean = false;
  // titolo principale della pagina
  titlePrincipal: string;
  // variabili per wizard
  wizard: boolean;
  mandatoryNotCompiled: number;
  nextStepWizard: string;
  addDocumentFormTitleArray: Array<string>;
  urlConcludiInserimento: string;
  nomePagina: string;
  tipoPratica: string;
  subscriptionctxMenuSezioni: Subscription;
  titleSection: string;
  titleControparti: string = "Parti";
  titleAltreParti: string = "Soggetti Terzi";
  titleScadenze: string = "Adempimenti";
  idFascicolo: string = "";
  demoData: TreeModel;
  treeData: FileFolders[] = [];
  itemSelected: FileFolders;
  separatorePathLogico: string;
  docToMove: FileFolders;
  fileFoldersTo: FileFolders;
  refreshData: boolean;
  XSRF: string;
  public loading: boolean;
  public fileData: FileData = new FileData();
  fileUploadList: DocumentoAllegato[] = [];
  searchIdDoc: string = "";
  esn: string;
  descrittori;
  accordions = stepMap;
  listaDocumenti;
  cartellaCorrente:any;
  descrittoriFolderMapping: Array<{esn: string, elementsKey: string, documentKey: string}> = [
    {esn: "SezioneControparti", elementsKey: "controparti", documentKey: "documentiControparti"},
    {esn: "SezioneAltreParti", elementsKey: "altreParti" , documentKey: "documentiAltreParti"},
    {esn: "SezioneScadenze", elementsKey: "scadenze" , documentKey: "documentiScadenze"},
    {esn: "SezioneAtti", elementsKey: "atti" , documentKey: "documentiAtti"},
    {esn: "SezioneDocumentazioneAllegata", elementsKey: "documentazione" , documentKey: "documentiFascicolo"},
  ];
  sezioneMapping = {
    'idSezioneAtti': 'atti',
    'idSezioneEsiti': 'esiti',
    'idSezioneScadenze': 'scadenze',
    'idSezioneIncassi': 'incassi',
    'idSezioneFatture': 'fatture',
    'idSezioneAltreParti': 'altreparti', //sggett terzi
    'idSezioneControparti': 'controparti',
    'idSezioneLegali': 'legaliincaricati',
    'idSezioneParcelle': 'parcelle',
    'idSezionePagamenti': 'pagamenti',
    'idSezioneDocumentazioneAllegata': 'documentazione'
  }

  constructor(
    private viewManager: ViewManagerService,
    private operationService: OperationsService,
    private routingService: RoutingConfigurationUtilService,
    private helpersService: HelpersService,
    protected fascicoliMappingService: FascicoliMappingService,
    private dialog: DialogService,
    private creazionePraticaStoreService: CreazionePraticaStoreService
  ) {
    this.insertUrlArray = this.getUrlAddDocument();
    this.deleteUrlArray = this.getUrlRemoveDocFromSezione();
    this.creazionePraticaStoreService.sectionLoad$.subscribe(
      sezione => {
        if(!!sezione) {
          let indexSez = this.sezioni.findIndex(x => x.esn === sezione.esn);
          if(indexSez > -1) {
            this.sezioni[indexSez].id = sezione.id;
          }
          this.accordions.forEach(
            () => {
              if(this.sezioni && this.sezioni.length > 0) {
                this.updateTree(sezione.esn);
              }
            }
          )
        }
      }
    )
  }
  private updateTree(esn: string) {
    let index = this.accordions.findIndex(x => x.context === esn);
    let properties = this.accordions[index].properties;
    let sezioneIndex = this.sezioni.findIndex(x => x.esn === esn);
    let descrittoreIndex = this.descrittoriFolderMapping.findIndex(x => x.esn === esn);
    let elements = properties.sezione[this.descrittoriFolderMapping[descrittoreIndex].elementsKey];
    this.sezioni[sezioneIndex][this.descrittoriFolderMapping[descrittoreIndex].elementsKey] = elements;
    if (this.descrittori?.length > 0 && !!this.listaDocumenti) {
      this.listaDocumenti[this.descrittoriFolderMapping[descrittoreIndex].documentKey] = properties.sezione.documentiAggregati;
      this.prepareTreeView(this.listaDocumenti, this.descrittori);
    }
  }

//
  ngOnInit() {
    this.wizard = true;
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
    let properties = this.accordions[index].properties;
    this.fascicolo = properties.fascicolo;
    if(this.fascicolo.id) {
      this.getDescrittoriAndDocumentList();
      this.subscriptionListDocumentazione = this.viewManager.documentazione$.subscribe(
        (documenti) => {
            this.getDescrittoriAndDocumentList();
        }
      );
    }
  }

  private getDescrittoriAndDocumentList() {
    this.helpersService.getDescrittoriFascicolo(this.getTipoPratica().endpoint, this.getTipoPratica().id, this.getTipoFascicolo().id).subscribe(
      descrittori => {
        let isDocumentazioneAllegataReadable: boolean = false;
        let newDescrittori = [];
        descrittori.forEach(itm => {
          let index = this.descrittoriFolderMapping.findIndex(x => itm.entitySimpleName === x.esn) > -1;
          if (index) {
            newDescrittori.push(itm);
            this.descrittori = newDescrittori;
          }
        });
        if (newDescrittori.length > 0) {
          let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
          let properties = this.accordions[index].properties;
          for (let descrittore of newDescrittori) {
            if (!this.routingService.isFascicoloWritable(
              properties.fascicolo.praticaBase
            )) {
              descrittore.writable = false;
            }
            if (descrittore.entitySimpleName ===
              NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO &&
              descrittore.readable) {
              isDocumentazioneAllegataReadable = true;
            }
          }
        }

        if (isDocumentazioneAllegataReadable &&
          newDescrittori) {
          // debugger;
          this.descrittoriSezione = newDescrittori;
          let i = 0;
          let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
          let properties = this.accordions[index].properties;
          for (let descrittore of newDescrittori) {
            i = this.composeSections(properties, descrittore, i);
          }
          this.getSezioni(this.sezioni, properties.fascicolo);
        }
        this.getListDocumentazione(newDescrittori);
      }
    );
  }



  updateSection(sezione, properties: { [key: string]: any; title: string; id: string; mandatory: boolean; }, descrittore: any) {
    for (let idDescrittore of IdDescrittoriDiSezione.TutteLeSezioni) {
      // if (!(
      //   properties.fascicolo?.tipoFascicolo?.endpoint ===
      //   "parere" && idDescrittore.nomeCampoId === "idSezioneAtti"
      // )) {
        // todo: da fare a livello di permessi/descrittori
        if (descrittore.readable &&
          descrittore.entitySimpleName === idDescrittore.esn) {
          sezione = [];
          if (idDescrittore.nomeCampoId ===
            "idSezioneDocumentazioneAllegata") {
              sezione["isMain"] = true;
          } else {
            sezione["isMain"] = false;
          }
          sezione["writable"] = descrittore.writable;
          sezione["esn"] = idDescrittore.esn;
          sezione["nomeCampoId"] = idDescrittore.nomeCampoId;
          sezione["nomeSezione"] =
            idDescrittore.nomeCampoId === "idSezioneScadenze"
              ? this.titleScadenze
              : idDescrittore.nomeCampoId === "idSezioneControparti"
                ? this.titleControparti
                : idDescrittore.nomeCampoId === "idSezioneAltreParti"
                  ? this.titleAltreParti
                  : idDescrittore.nomeSezione.charAt(0).toUpperCase() +
                  idDescrittore.nomeSezione.slice(1);
                  sezione["tipoPraticaId"] = this.getTipoPratica();
                  sezione["praticaId"] =
            properties.fascicolo.idParent;
          // this.sezioni[i]["posizionePratica"] =
          //   properties.fascicolo.praticaBase.posizione;
          sezione["fascicoloId"] =
            properties.fascicolo.id;
          // this.sezioni[i]["posizioneFascicolo"] =
          //   properties.fascicolo.intestazione.campi.posizione;
          sezione["documenti"] = [];
          sezione["tipoSezione"] = new TipoSezione();
          sezione["entities"] = false;
          sezione[idDescrittore.nomeCampoEntityList] = [];
        }
      // }
    }
  }

  private composeSections(properties: { [key: string]: any; title: string; id: string; mandatory: boolean; }, descrittore: any, i: number) {
    for (let idDescrittore of IdDescrittoriDiSezione.TutteLeSezioni) {
      // if (!(
      //   properties.fascicolo?.tipoFascicolo?.endpoint ===
      //   "parere" && idDescrittore.nomeCampoId === "idSezioneAtti"
      // )) {
        // todo: da fare a livello di permessi/descrittori
        if (descrittore.readable &&
          descrittore.entitySimpleName === idDescrittore.esn) {
          this.sezioni[i] = [];
          if (idDescrittore.nomeCampoId ===
            "idSezioneDocumentazioneAllegata") {
            this.sezioni[i]["isMain"] = true;
          } else {
            this.sezioni[i]["isMain"] = false;
          }
          this.sezioni[i]["writable"] = descrittore.writable;
          this.sezioni[i]["esn"] = idDescrittore.esn;
          this.sezioni[i]["nomeCampoId"] = idDescrittore.nomeCampoId;
          let index = this.accordions.findIndex(x => x.context === this.sezioni[i].esn);
          this.sezioni[i]["nomeSezione"] = this.accordions[index].properties.title;
            // idDescrittore.nomeCampoId === "idSezioneScadenze"
            //   ? this.titleScadenze
            //   : idDescrittore.nomeCampoId === "idSezioneControparti"
            //     ? this.titleControparti
            //     : idDescrittore.nomeCampoId === "idSezioneAltreParti"
            //       ? this.titleAltreParti
            //       : idDescrittore.nomeSezione.charAt(0).toUpperCase() +
            //       idDescrittore.nomeSezione.slice(1);
          this.sezioni[i]["tipoPraticaId"] = this.getTipoPratica();
          this.sezioni[i]["praticaId"] =
            properties.fascicolo.idParent;
          // this.sezioni[i]["posizionePratica"] =
          //   properties.fascicolo.praticaBase.posizione;
          this.sezioni[i]["fascicoloId"] =
            properties.fascicolo.id;
          // this.sezioni[i]["posizioneFascicolo"] =
          //   properties.fascicolo.intestazione.campi.posizione;
          this.sezioni[i]["documenti"] = [];
          this.sezioni[i]["tipoSezione"] = new TipoSezione();
          this.sezioni[i]["entities"] = false;
          this.sezioni[i][idDescrittore.nomeCampoEntityList] = [];
          i++;
        }
      // }
    }
    return i;
  }

  getTipoPratica() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
    return this.accordions[index].properties.tipoPratica;
  }

  getTipoFascicolo() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
    return this.accordions[index].properties.tipoFascicolo;
  }

  getIdFascicolo() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
    return this.accordions[index].properties.fascicolo.id;
  }

  getUrlAddDocToDocumentazioneAllegata() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneDocumentazioneAllegata;
    let idFascicolo = this.accordions[index].properties.fascicolo.id
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/${idFascicolo}/sez/documentazione/${idSezione}/documento`;
    return url;
  }

  getUrlRemoveDocFromDocumentazioneAllegata() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneDocumentazioneAllegata;
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/documentazione/${idSezione}/documento`;
    return url;
  }

  getListDocumentazione(descrittori) {
    if(descrittori) {
      this.operationService
        .getDocumentazione(this.getTipoPratica(), this.getIdFascicolo())
        .subscribe((readSezioneResponse) => {
          this.listaDocumenti = readSezioneResponse;
          this.prepareTreeView(readSezioneResponse, descrittori);
          if (this.cartellaCorrente) {
            this.selezionaCartellaCorrente(this.cartellaCorrente);
          }
        });
    }
  }

   selezionaCartellaCorrente(cartella: FileFolders) {
    const pathTarget = cartella.path;
    
      let cartellaTrovata: FileFolders | null = null;  
      if (cartella.root && !pathTarget) {
        cartellaTrovata = this.treeData.find(folder => folder.name === cartella.name) || null;
      } else {
        cartellaTrovata = this.findFolderByPath(this.treeData, pathTarget);
      }
    
      if (cartellaTrovata) {
        this.itemSelected = cartellaTrovata;
        //console.log("Cartella ripristinata:", cartellaTrovata.name);
      } else {
        console.log("Cartella non trovata:", pathTarget);
      }
  }

  findFolderByPath(folders: FileFolders[], path: string): FileFolders | null {
    for (let folder of folders) {
      if (folder.path === path) {
        return folder;
      }
  
      if (folder.children?.length) {
        const found = this.findFolderByPath(folder.children, path);
        if (found) return found;
      }
    }
  
    return null;
  }

  prepareTreeView(listDocumentazione, descrittori) {
    this.treeData = [];
    this.separatorePathLogico = listDocumentazione.separatorePathLogico;
    const dirFolder: Array<FileFolders>[] = [];
    descrittori.forEach((descrittore, i) => {
      const sezione = {
        ...this.sezioni.find((sez) => sez.esn === descrittore.entitySimpleName),
      };
      if (sezione.esn) {
        const nomeSezione = sezione.esn.replace("Sezione", ""); // descrittore.entitySimpleName.replace('Sezione', '');
        let documentiSezione = listDocumentazione["documenti" + nomeSezione]
          ? listDocumentazione["documenti" + nomeSezione]
          : [];
        if (nomeSezione === "DocumentazioneAllegata") {
          sezione.nomeSezione = "Documentazione fascicolo";
          documentiSezione = listDocumentazione["documentiFascicolo"]
            ? listDocumentazione["documentiFascicolo"]
            : [];
        }
        dirFolder[sezione.nomeCampoId] = new Array<FileFolders>();
        if (nomeSezione !== "DocumentazioneAllegata") {
          documentiSezione.forEach((doc) => {
            const index = dirFolder[sezione.nomeCampoId].findIndex(
              (el) => el.code === doc.entitaCollegata.id
            );
            if (index > -1) {
              // esiste l'entità collegata
              dirFolder[sezione.nomeCampoId][index].children.push(
                new FileFolders(
                  doc.nomeFile,
                  doc.id,
                  null,
                  false,
                  doc.nomeFile,
                  doc.dataAggiornamento,
                  doc,
                  sezione
                )
              );
            } else {
              const d: FileFolders = new FileFolders(
                doc.entitaCollegata.titolo,
                doc.entitaCollegata.id,
                [
                  new FileFolders(
                    doc.nomeFile,
                    doc.id,
                    null,
                    false,
                    doc.nomeFile,
                    doc.dataAggiornamento,
                    doc,
                    sezione
                  ),
                ],
                false,
                doc.entitaCollegata.titolo,
                doc.dataAggiornamento,
                { ...doc, refDocumentale: null },
                sezione
              );
              dirFolder[sezione.nomeCampoId].push(d);
            }
          });
        } else {
          const tempDirFolder: Array<FileFolders>[] = [];
          const mapFolder = new Map();
          documentiSezione.forEach((doc, index) => {
            const isDir = !!doc.refDocumentale;
            const entityArray = doc.nomeFile.split(this.separatorePathLogico);
            const nomeFileDir = this.getNameFileDir(doc.nomeFile);

            if (!tempDirFolder[entityArray.length]) {
              tempDirFolder[entityArray.length] = new Array<FileFolders>();
            }
            tempDirFolder[entityArray.length].push(
              new FileFolders(
                nomeFileDir,
                doc.id,
                null,
                false,
                doc.nomeFile,
                doc.dataAggiornamento,
                doc,
                sezione
              )
            );
            mapFolder.set(
              entityArray.length,
              tempDirFolder[entityArray.length]
            );
          });

          /*mapFolder.forEach( (value, key, map) => {
          console.log(key);
          console.log(value);
        });*/
          for (let index = 1; index <= mapFolder.size; index++) {
            mapFolder.get(index).forEach((folder) => {
              if (
                folder.documento.refDocumentale === null
              ) {
                // directory di primo livello
                if (!folder.children) {
                  folder.children = new Array<FileFolders>();
                }
                const folderChildArray = this.getFolderChild(
                  mapFolder,
                  folder,
                  index
                );
                folder.children.push(...folderChildArray);
              }
            });
          }

          if (mapFolder.size > 0) {
            dirFolder[sezione.nomeCampoId].push(...mapFolder.get(1)); // aggiungo i primi livelli contentnei anche i sotto child
          }
        }
        this.treeData.push(
          new FileFolders(
            sezione.nomeSezione,
            sezione.nomeCampoId,
            dirFolder[sezione.nomeCampoId],
            true,
            "",
            null,
            null,
            sezione
          )
        );
      }
    });
    this.demoData = new TreeModel(
      "code",
      "name",
      "children",
      this.treeData,
      null,
      true,
      "Navigazione",
      "demoData_folderStructure",
      "glyphicon-folder-close",
      "glyphicon-folder-open",
      "glyphicon-file"
    );
    if (this.searchIdDoc) {
      this.treeData.forEach((el) => {
        if (
          el.children &&
          el.children.length > 0 &&
          el.children[0].children &&
          el.children[0].children.findIndex(
            (e) => e.documento.id === this.searchIdDoc
          ) > -1
        ) {
          this.itemSelected = el.section.isMain ? el : el.children[0];
        }
      });
      if (!this.itemSelected) {
        this.itemSelected = null;
      }
      this.searchIdDoc = "";
    } else {
      this.itemSelected = this.itemSelected
        ? this.treeData.find(
            (el) => el.code === this.itemSelected.section.nomeCampoId
          )
        : null;
    }
    this.refreshData = true;
  }

  goSectionRoot(sectionRootId) {
    // this.itemSelected.section.nomeCampoId
    this.itemSelected = this.treeData.find((el) => el.code === sectionRootId);
    this.refreshData = true;
  }

  goSectionChild(objPath) {
    let navigatorItemParent = this.treeData.find((el) => el.code === objPath.sectionRootId);
    let navigatorItem = navigatorItemParent;

    objPath.itemPath.split(this.separatorePathLogico).forEach(pathElement => {
      navigatorItem.children.forEach(file => {
        if(file.name === pathElement && (file.documento && !file.documento.refDocumentale)) {
          navigatorItemParent = navigatorItem;
          navigatorItem = file;
        }
      })
    });

    this.itemSelected = navigatorItem;
    this.refreshData = true;
  }

  setRefreshData(refresh) {
    this.refreshData = refresh;
  }

  getFolderChild(mapFolder, folder, index) {
    if (!mapFolder.get(index + 1)) {
      return [];
    }
    const folderChildArray = mapFolder.get(index + 1).filter((subFolder) => {
      return folder.path == this.extractPathBeforeLastSlash(subFolder.path);
    });
    return folderChildArray;
  }

  setItemSelected(item) {
    this.itemSelected = item;
  }

  extractPathBeforeLastSlash(path: string): string {
    const lastSlashIndex = path.lastIndexOf('/');
    if (lastSlashIndex === -1) {
      return "";
    }
    return path.substring(0, lastSlashIndex);
  }


  getSezioni(sezioni,fascicolo) {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    for (let sezione of sezioni) {
      if (fascicolo[sezione["nomeCampoId"]]) {
        sezione["id"] = fascicolo[sezione["nomeCampoId"]];
        let url = this.getReadSezioneUrl(tipoPratica, tipoFascicolo, sezione);
        this.readSezione(
          url,
          fascicolo[sezione["nomeCampoId"]],
          sezione["esn"]
        );
      } else {
        if (sezione) {
          sezione["id"] = PropertiesSettings.NEW_SEZIONE;
        }
      }
    }
    // this.getDocumentazione();
  }

  private getReadSezioneUrl(tipoPratica: any, tipoFascicolo: any, sezione: any) {
    return `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/${this.sezioneMapping[sezione["nomeCampoId"]]}`;
  }

  readSezione(url: string, idSezione: string, esn: string) {
    if (idSezione != PropertiesSettings.NEW_SEZIONE) {
      this.operationService
        .readSezione(url, idSezione)
        .subscribe((readSezioneResponse) =>
          {
            this.creazionePraticaStoreService.onDocAdded(readSezioneResponse.sezione);
            this.setDocumenti(readSezioneResponse, esn)
          }
        );
    }
  }

  setDocumenti(readSezioneResponse, esn) {
    for (let idDescrittore of IdDescrittoriDiSezione.TutteLeSezioni) {
      if (idDescrittore.esn === esn) {
        for (let sezione of this.sezioni) {
          if (sezione.id === readSezioneResponse.sezione.id) {
            sezione.documenti = readSezioneResponse.sezione.documentiAggregati;
            sezione[idDescrittore.nomeCampoEntityList] =
              readSezioneResponse["sezione"][idDescrittore.nomeCampoEntityList];
            sezione.tipoSezione = readSezioneResponse.sezione.tipoSezione;
            sezione.entities =
              sezione[idDescrittore.nomeCampoEntityList].length > 0;
          }
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.subscriptionIntestazioneFascicolo) {
      this.subscriptionIntestazioneFascicolo.unsubscribe();
    }
    if (this.subscriptionListDocumentazione) {
      this.subscriptionListDocumentazione.unsubscribe();
    }
    this.viewManager.completeBody();
  }

  refresh(response) {
    const itemSelected = this.itemSelected;
    console.log("itemSelected", itemSelected);
    if (itemSelected) {
      this.cartellaCorrente = itemSelected;
      console.log("Cartella corrente salvata:", this.cartellaCorrente);
    }
    if (response.sezione) {
      let esn = "SezioneDocumentazioneAllegata";
      this.fascicolo["idSezioneDocumentazioneAllegata"] = response.sezione.id;

      // this.readSezione(
      //   this.sezioneMapping["idSezioneDocumentazioneAllegata"],
      //   response.sezione.id,
      //   esn
      // );
      for (let sezione of this.sezioni) {
        if (sezione.esn === esn) {
          sezione.id = response.sezione.id;
        }
      }
    } else {
      let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
      let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
      let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
      for (let sezione of this.sezioni) {
        let url = this.getReadSezioneUrl(tipoPratica, tipoFascicolo, sezione);
        this.readSezione(
          url,
          sezione.id,
          sezione.esn
        );
      }
    }
    this.refreshData = false;
    this.getListDocumentazione(this.descrittori);
  }

  refreshAfterUploadNewVersion(documento: DocumentoAllegato) {
    if ('primary' in documento) {
      delete (documento as any).primary;    
    }
    let request: UpdateMetadatiDocumentoRequest =
      new UpdateMetadatiDocumentoRequest();
    request.documento = documento;
    request.dataInput = new DataInput(
      this.fascicolo.praticaBase.id,
      this.fascicolo.id,
      this.fascicolo.praticaBase.intestazione.campi.posizionePratica,
      this.fascicolo.posizione,
      this.tipoPratica
    );

    this.operationService
      .updateMetadatiDocumento(request)
      .subscribe((response) => this.docUpdated(response));
  }

  from(event) {
    this.docToMove = event;
  }

  to(event) {
    const fileFoldersTo: FileFolders = event;
    this.fileFoldersTo = fileFoldersTo;
    if (
      this.docToMove.path === this.fileFoldersTo.path ||
      !this.fileFoldersTo.section.isMain
    ) {
      // same dir 'inizio' 'fine' || dir 'fine' is section
      this.refreshData = true;
      return;
    }
    if (!this.docToMove.documento.refDocumentale) {
      // is directory in 'Documentazione Fascicolo' -> rename dir
      this.renameDirToMove();
      return;
    }
    if (!this.itemSelected) {
      this.itemSelected = this.fileFoldersTo;
    }
    if (
      this.docToMove &&
      this.docToMove.section.isMain &&
      fileFoldersTo.section.isMain
    ) {
      // sposto file dentro sezione documentazione fascicolo
      this.updateMetadatiDocumento(this.docToMove, fileFoldersTo);
    } else {
      this.displayMoveDocModalDrop(
        this.docToMove,
        this.itemSelected.section,
        fileFoldersTo
      );
    }
  }

  renameDirToMove() {
    let doc: DocumentoAllegato;
    const nomeDir = this.getNameFileDir(this.docToMove.documento.nomeFile);
    const nomeFile =
      this.fileFoldersTo.path + this.separatorePathLogico + nomeDir;
    doc = {
      ...this.fileFoldersTo.documento,
      nomeFile,
      titolo: nomeFile,
    };
    this.operationService
      .updateMetadatiDir(
        this.getUrlAddDocToDocumentazioneAllegata(),
        doc,
        this.fileFoldersTo.section.id
      )
      .subscribe((response) => {
        this.docUpdated(response);
        this.refreshData = false;
        // this.getListDocumentazione();
      });
  }

  getNameFileDir(nameFile) {
    return nameFile.split(this.separatorePathLogico).slice(-1)[0];
  }

  docUpdated(response) {
    for (let sezione of this.sezioni) {
      this.readSezione(
        this.sezioneMapping[sezione.nomeCampoId],
        sezione.id,
        sezione.esn
      );
    }
  }

  displayMoveDocModal(event, sezione) {
    this.docSpostaModal.initForm(
      sezione,
      this.sezioni,
      this.fascicolo.id,
      event
    );
  }

  displayMoveDocModalDrop(
    docToMove: FileFolders,
    sectionFrom: Sezione,
    fileFoldersTo: FileFolders
  ) {
    // this.docSpostaModal.initForm(sezione, this.sezioni,this.fascicolo.id, event);
    if (docToMove && fileFoldersTo && fileFoldersTo.section && sectionFrom) {
      const formTitle =
        "Sposta documento - " + fileFoldersTo.section.nomeSezione;
      const objMoveDoc = {
        idDocumento: docToMove.documento.id,
        tipoSezioneDestinazione: fileFoldersTo.section.tipoSezione,
        tipoSezioneSorgente: sectionFrom.tipoSezione,
      };

      this.displayAddDocModal(formTitle, fileFoldersTo, objMoveDoc, true);
      // this.displayAddDocModal(event.formTitle, event.sezione, event.request, true);
    }
  }

  updateMetadatiDocumento(
    documentoUpdated: FileFolders,
    fileFoldersTo: FileFolders
  ) {
    if ('primary' in documentoUpdated) {
      delete (documentoUpdated as any).primary;    
    }
    let request: UpdateMetadatiDocumentoRequest =
      new UpdateMetadatiDocumentoRequest();
    request.documento = {
      ...documentoUpdated.documento,
      nomeFile:
        fileFoldersTo.path +
        (fileFoldersTo.path !== "" ? this.separatorePathLogico : "") +
        this.getNameFileDir(documentoUpdated.documento.nomeFile),
    };
    request.dataInput = new DataInput(
      this.fascicolo.praticaBase.id,
      this.fascicolo.id,
      this.fascicolo.praticaBase.intestazione.campi.posizionePratica,
      this.fascicolo.posizione,
      this.tipoPratica
    );

    this.operationService
      .updateMetadatiDocumento(request)
      .subscribe((response) => {
        this.docUpdated(response);
        this.refreshData = false;
        // this.getListDocumentazione();
      });
  }

  displayDetailFromProtocol(document: ResponseDocumentProtocol) {
   this.fascicolo.numeroFascicoloProtocollo =this.fascicolo.numeroFascicoloProtocollo ?this.fascicolo.numeroFascicoloProtocollo : document.dossierNumber;
   this.fascicolo.praticaBase.numeroFascicoloProtocollo =this.fascicolo.praticaBase.numeroFascicoloProtocollo ?this.fascicolo.praticaBase.numeroFascicoloProtocollo : document.dossierNumber;
   this.fascicolo.numeroProtocollo = this.fascicolo.numeroProtocollo ? this.fascicolo.numeroProtocollo : document.protocolNumber;
   this.fascicolo.praticaBase.numeroProtocollo =this.fascicolo.praticaBase.numeroProtocollo ?this.fascicolo.praticaBase.numeroProtocollo : document.protocolNumber;
    this.fascicolo.numeroFascicoloProtocollo = this.fascicolo.numeroFascicoloProtocollo ? this.fascicolo.numeroFascicoloProtocollo : document.dossierNumber;
    this.detailDocument.showDetailModal(document.document)
    this.getDescrittoriAndDocumentList();
  }

  displayDocVersionUpdateModal(documento: DocumentoAllegato) {
    this.docVersionUpdateModal.initForm(documento);
  }

  displayDocVersionHistoryModal(documento: DocumentoAllegato) {
    this.docVersionHistoryModal.initContent(documento, this.fascicolo);
  }

  displayDocUpdateMetadatiModal(documento: DocumentoAllegato) {
    if (documento.refDocumentale) {
      const ref = this.dialog.open(UpdateMetadatiComponent, {
        data: {
          style: { width: "70%"},
          title: 'Modifica metadati',
          documento: documento,
          fascicolo: this.fascicolo,
          tipoPratica: this.getTipoPratica().id
        }
      });
      ref.afterClosed.subscribe(event => {
        if(!event || event.closeEvent) {
          // documento.primary = false;
          return
        };
        if(!!event.response) {
          this.refresh(event.response);
        }
      });
    } else {
      this.displayAddFolderModal(
        this.addDocFormTitles[this.itemSelected.section.id],
        this.itemSelected.section,
        null,
        null,
        documento
      );
    }
  }

  getSezione(sezione) {
    this.esn = sezione;
  }

  onSelectCategoriaDocumento(event) {
    this.displayAddDocModalOld(
      event.formTitle,
      event.sezione,
      event.request,
      true
    );
  }

  onDocumentoSpostato(event) {
    this.docSpostaModal.manageModal(event);
    this.updateMetadatiDocumento(this.docToMove, this.fileFoldersTo);
    //this.modalNotifyService.customMessage('Operazione avvenuta con successo.');
  }

  displayAddDocModal(
    evt,
    fileFoldersTo = this.fileFoldersTo,
    request = null,
    isSpostaDoc = false
  ) {
    console.log(evt);
    if (!fileFoldersTo) {
      fileFoldersTo = this.itemSelected;
    }
    let event = null;
    let fileList: DocumentoAllegato[] = [];
    if (evt && evt.event) {
      event = evt.event;
      fileList = evt.fileUploadList;
    } else {
      event = evt;
    }
    if (
      fileFoldersTo &&
      fileFoldersTo.section &&
      fileFoldersTo.section.isMain
    ) {
      // documentazione allegata
      this.docAddModal.initForm(
        this.getUrlAddDocToDocumentazioneAllegata(),
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request,
        fileList,
        fileFoldersTo,
        this.separatorePathLogico,
        null,
        null,
        null,
      );
    } else if (fileFoldersTo.root) {
      const url = this["insertUrlArray"][fileFoldersTo.section["nomeCampoId"]];
      this.docAddModal.initForm(
        url,
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request,
        fileList,
        null,
        null,
        null,
        null,
        null,
      );
    } else if (fileFoldersTo.section && fileFoldersTo.documento) {
      const url = this["insertUrlArray"][fileFoldersTo.section["nomeCampoId"]];
      const entitaCollegata = this.getEntity(
        fileFoldersTo.section,
        fileFoldersTo.documento.entitaCollegata.id
      );
      this.docAddModal.initForm(
        url,
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        true,
        entitaCollegata,
        isSpostaDoc,
        request,
        fileList,
        null,
        null,
        null,
        null,
        null,
      );
    }
  }

  exportFile(
    evt,
    fileFoldersTo = this.fileFoldersTo,
    request = null,
    isSpostaDoc = false
  ) {
    if (!fileFoldersTo) {
      fileFoldersTo = this.itemSelected;
    }
    let event = null;
    let fileList: DocumentoAllegato[] = [];
    if (evt && evt.event) {
      event = evt.event;
      fileList = evt.fileUploadList;
    } else {
      event = evt;
    }
    if (
      fileFoldersTo &&
      fileFoldersTo.section &&
      fileFoldersTo.section.isMain
    ) {
      // documentazione allegata
      this.docAddModal.initForm(
        this.getUrlAddDocToDocumentazioneAllegata(),
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request,
        fileList,
        fileFoldersTo,
        this.separatorePathLogico,
        null,
        null,
        null,
      );
    } else if (fileFoldersTo.root) {
      const url = this["insertUrlArray"][fileFoldersTo.section["nomeCampoId"]];
      this.docAddModal.initForm(
        url,
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request,
        fileList,
        null,
        null,
        null,
        null,
        null,
      );
    } else if (fileFoldersTo.section && fileFoldersTo.documento) {
      const url = this["insertUrlArray"][fileFoldersTo.section["nomeCampoId"]];
      const entitaCollegata = this.getEntity(
        fileFoldersTo.section,
        fileFoldersTo.documento.entitaCollegata.id
      );
      this.docAddModal.initForm(
        url,
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        true,
        entitaCollegata,
        isSpostaDoc,
        request,
        fileList,
        null,
        null,
        null,
        null,
        null,
      );
    }
  }

  displayAddDocModalOld(event, sezione, request = null, isSpostaDoc = false) {
    if (sezione.isMain) {
      this.docAddModal.initForm(
        this.getUrlAddDocToDocumentazioneAllegata(),
        sezione,
        sezione.fascicoloId,
        sezione.isMain,
        sezione.esn,
        event,
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request
      );
    } else {
      let url = this["insertUrlArray"][sezione["nomeCampoId"]];
      this.docAddModal.initForm(
        url,
        sezione,
        sezione.fascicoloId,
        sezione.isMain,
        sezione.esn,
        event,
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request
      );
    }
  }

  displayAddFolderModal(
    evt,
    sezione,
    request = null,
    isSpostaDoc = false,
    documento: DocumentoAllegato = null
  ) {
    this.docAddModal.initForm(
      this.getUrlAddDocToDocumentazioneAllegata(),
      sezione,
      sezione.fascicoloId,
      sezione.isMain,
      sezione.esn,
      "Nome cartella",
      this.addDocToEntity,
      null,
      isSpostaDoc,
      request,
      null,
      this.itemSelected,
      this.separatorePathLogico,
      true,
      documento,
      this.tipoPratica
    );
  }

  getEntity(sezione, idEntityCollegata) {
    let arrayList = [];
    for (const idDescrittore of IdDescrittoriDiSezione.TutteLeSezioni) {
      if (idDescrittore.esn === sezione.esn) {
        arrayList = sezione[idDescrittore.nomeCampoEntityList];
      }
    }
    return arrayList.find((el) => el.id === idEntityCollegata);
  }

  removeDocFromSezione(documento, sezione) {
    this.cartellaCorrente = this.cartellaCorrente ?? documento.folder ?? null;
    if (sezione.isMain) {
      this.operationService
        .removeDocumentoFromSezDocumentiAllegatiOrdinario(
          documento,
          this.getUrlRemoveDocFromDocumentazioneAllegata(),
          sezione.id
        )
        .subscribe((response) => this.refresh(response));
    } else if (!sezione.isMain) {
      let url = this["deleteUrlArray"][sezione["nomeCampoId"]];
      this.operationService
        .removeDocumentoToEntity(documento, url, documento.entitaCollegata.id)
        .subscribe((response) => this.refresh(response));
    }
  }

  removeDocFromSezioneConFascicolo(event: { documento, nuovoFascicolo }, sezione) {
    const documento = event.documento;
    const nuovoFascicolo = event.nuovoFascicolo;
    this.cartellaCorrente = this.cartellaCorrente ?? documento.folder ?? null;
    const idFascicolo = nuovoFascicolo.idFascicolo; // dal nuovo fascicolo selezionato
    this.operationService.removeDocumentoConFascicolo(documento,sezione.id,idFascicolo)
    .subscribe(response => {
      this.refresh(response);
    });
  }

  getUrlRemoveDocFromSezione() {
    let urlArray: Array<any> = [];
    for (let idDescrittori of IdDescrittoriDiSezione.TutteLeSezioni) {
      urlArray["idSezioneControparti"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_CONTROPARTE;
      urlArray["idSezioneLegali"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_LEGALE_INCARICATO;
      urlArray["idSezioneAltreParti"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ALTRAPARTE;
      urlArray["idSezioneAtti"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ATTO;
      urlArray["idSezioneEsiti"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ESITO;
      urlArray["idSezioneParcelle"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_PARCELLA;
      urlArray["idSezioneFatture"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_FATTURA;
      urlArray["idSezioneIncassi"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_INCASSO;
      urlArray["idSezionePagamenti"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_PAGAMENTO;
      urlArray["idSezioneScadenze"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_SCADENZA;
      urlArray["idSezioneProveScritte"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_PROVASCRITTA;
      urlArray["idSezioneTitoliEsecutivi"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_TITOLO_ESECUTIVO;
      urlArray["idSezioneBeniPignoratiMobili"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_BENEMOBILE;
        urlArray["idSezioneSchedeRecupero"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_SCHEDA_RECUPERO;
        urlArray["idSezioneSchedeEsecuzione"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_SCHEDA_ESECUZIONE;
      urlArray["idSezioneDatiPignoramento"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_DATI_PIGNORAMENTO;
    }
    return urlArray;
  }

  getUrlAddDocument(): Array<string> {
    let urlArray: Array<any> = [];
    for (let idDescrittori of IdDescrittoriDiSezione.TutteLeSezioni) {
      urlArray["idSezioneControparti"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_CONTROPARTE;
      urlArray["idSezioneLegali"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_LEGALE_INCARICATO;
      urlArray["idSezioneAltreParti"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_ALTRAPARTE;
      urlArray["idSezioneAtti"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_ATTO;
      urlArray["idSezioneEsiti"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_ESITO;
      urlArray["idSezioneParcelle"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_PARCELLA;
      urlArray["idSezioneFatture"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_FATTURA;
      urlArray["idSezioneIncassi"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_INCASSO;
      urlArray["idSezionePagamenti"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_PAGAMENTO;
      urlArray["idSezioneScadenze"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_SCADENZA;
      urlArray["idSezioneProveScritte"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_PROVASCRITTA;
      urlArray["idSezioneTitoliEsecutivi"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_TITOLO_ESECUTIVO;
      urlArray["idSezioneBeniPignoratiImmobili"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_BENEIMMOBILE;
      urlArray["idSezioneBeniPignoratiMobili"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_BENEMOBILE;
      urlArray["idSezioneSchedeRecupero"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_SCHEDA_RECUPERO;
      urlArray["idSezioneSchedeEsecuzione"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_SCHEDA_ESECUZIONE;
      urlArray["idSezioneDatiPignoramento"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_DATI_PIGNORAMENTO;
    }
    return urlArray;
  }

  getAddDocumentFormTitle(): Array<string> {
    let formTitleArray: Array<any> = [];
    for (let idDescrittori of IdDescrittoriDiSezione.TutteLeSezioni) {
      formTitleArray["idSezioneDocumentazioneAllegata"] = "Aggiungi documento";
      formTitleArray["idSezioneControparti"] =
        "Aggiungi documento - " + this.titleControparti; // Parte';
      formTitleArray["idSezioneLegali"] = "Aggiungi documento - Legale";
      formTitleArray["idSezioneAltreParti"] =
        "Aggiungi documento - " + this.titleAltreParti;
      formTitleArray["idSezioneAtti"] = "Aggiungi documento - Atto";
      formTitleArray["idSezioneEsiti"] = "Aggiungi documento - Esito";
      formTitleArray["idSezioneParcelle"] = "Aggiungi documento - Parcella";
      formTitleArray["idSezioneFatture"] = "Aggiungi documento - Fattura";
      formTitleArray["idSezioneIncassi"] = "Aggiungi documento - Incasso";
      formTitleArray["idSezionePagamenti"] = "Aggiungi documento - Pagamento";
      formTitleArray["idSezioneScadenze"] = "Aggiungi documento - Scadenza";
      formTitleArray["idSezioneProveScritte"] =
        "Aggiungi documento - Prova Scritta";
      formTitleArray["idSezioneTitoliEsecutivi"] =
        "Aggiungi documento - Titolo Esecutivo";
      formTitleArray["idSezioneBeniPignoratiImmobili"] =
        "Aggiungi documento - Bene Immobile";
      formTitleArray["idSezioneBeniPignoratiMobili"] =
        "Aggiungi documento - Bene Mobile";
        formTitleArray["idSezioneSchedeRecupero"] =
        "Aggiungi documento - Schede Recupero";
        formTitleArray["idSezioneSchedeEsecuzione"] =
        "Aggiungi documento - Schede Esecuzione";
        formTitleArray["idSezioneDatiPignoramento"] = "Aggiungi documento - Dati Pignoramento";
    }
    return formTitleArray;
  }

  fascicoloRefreshed(fascicolo: FascicoloFull) {
    //this.fascicolo = fascicolo;
    this.fascicolo = fascicolo;
  }

  /*** UPLOAD FILE SERVICE ***/

  uploadFileService(files) {
    this.loading = true;
    for (let i = 0; i < files.length; i++) {
      this.uploadFile(files[i], Number(i) == files.length - 1);
    }
  }

  uploadFile(file: File, isLastOne?): Promise<any> {
    if (!file.type) {
      // Bthis.modalNotifyService.customMessage("Non è possibile fare l'upload di cartelle!");
      this.loading = false;
      return;
    }

    this.XSRF =  this.getXSRFToken()['XSRF-TOKEN']

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(
              (this.fileData = (<FileUploadResponse>(
                JSON.parse(xhr.response)
              )).fileData)
            );
            this.setFileDataRequest(this.fileData);
            if (isLastOne) {
              this.loading = false;
              this.displayAddDocModal({
                event:
                  this.addDocFormTitles[this.itemSelected.section.nomeCampoId],
                fileUploadList: this.fileUploadList,
              }); // idSezioneDocumentazioneAllegata
            }
            // this.onReturn.emit(this.fileData);
          } else {;
            this.loading = false;
            // this.modalNotifyService.customMessage("L'operazione non è andata a buon fine.");
            reject(xhr.response);
          }
        }
      };
      xhr.open("POST", this.getXSRFToken()['XSRF-TOKEN'], true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("X-XSRF-TOKEN", this.XSRF);
      const formData = new FormData();
      formData.append("contenuto", file);
      formData.append("nomeFile", file.name);
      xhr.send(formData);
    });
  }

  getXSRFToken = () =>
  document.cookie.split('; ').reduce((acc, value) => {
    const cookie = value.split('=');
    acc[cookie[0]] = cookie[1];
    return acc;
  }, {});

  setFileDataRequest(fileData: FileData) {
    const fileDaAllegare = new DocumentoAllegato();
    fileDaAllegare.refDocumentale = fileData.refDocumentale;
    fileDaAllegare.nomeFile = fileData.nomeFile;
    fileDaAllegare.contentType = fileData.contentType;
    fileDaAllegare.contentSize = fileData.contentSize;
    fileDaAllegare.signedData = fileData.signedData ?? null;
    fileDaAllegare.algoritmoImprontaDocumento = fileData.algoritmoImprontaDocumento;
    fileDaAllegare.improntaDocumento = fileData.improntaDocumento;
    this.fileUploadList.push(fileDaAllegare);
  }

  retrieveEventDocSigned(itemSelected: FileFolders){
    this.itemSelected = itemSelected;
    // this.getListDocumentazione();
  }

  openProtocolDocumentsSelection(documento) {
    let arrayDocs = [];
    this.descrittori.forEach(descrittore => {
      let nomeSezione;
      if(descrittore.entitySimpleName === "SezioneDocumentazioneAllegata") {
        nomeSezione = "documentiFascicolo"
      } else {
        nomeSezione = descrittore.entitySimpleName.replace("Sezione", "documenti");
      }
      if(this.listaDocumenti[nomeSezione] && this.listaDocumenti[nomeSezione].length > 0) {
        arrayDocs = [...arrayDocs, ...this.listaDocumenti[nomeSezione]]
      }
    })
    let filteredDocs = arrayDocs.filter(el => el.numeroProtocollo === null && !!el.refDocumentale && el.id !== documento.id);
    if (filteredDocs.length>0) {
      const ref = this.dialog.open(ProtocolDocumentSelectionComponent, {
        data: {
          style: { width: "50%", height: '90vh' },
          title: 'Desideri selezionare uno o più allegati da associare a questo protocollo ?',
          documents: filteredDocs
        }
      });
      ref.afterClosed.subscribe(event => {
        if(!event || event.closeEvent) return;
        if(event.modalEvent === true) {
          this.displayProtocolDocModal(documento, event.selectedDocuments);
        }
      });
    }
    else  {
      this.displayProtocolDocModal(documento);
    }
  }

  displayProtocolDocModal(documento: DocumentoAllegato, documenti?: DocumentoAllegato[]) {
    let docList = [...[documento], ...(documenti || [])];
    this.docProtocolModal.initForm(documento,this.fascicolo.id, docList);
  }

  handleAnnullamento(resp: any) {
    console.log('Annullamento completato', resp);
    this.refresh(resp);
  }

}